import React, { useRef, useEffect, useState } from "react";
import {
  RegisterWrapper,
  LoginInputWrapper,
  LoginInput,
  VerifyInput
} from "../../UI/register";
import Pic from "../../../assets/image/send-message.png";
import { css } from "styled-components/macro";
import { Loading, Title } from "../../UI/general";
import ResendVerify from "./ReSendCountDown";
import fetchModule from "../../../utils/fetchingData";
import lstool from "../../../utils/localStorage";
import { toast } from "react-toastify";
import API from "./../../../configs/API";
import { createSendForm } from "../../../utils/form";
function VerifyPhone({ nextStep, prevStep, isCurrent }) {
  const WrapperRef = useRef();
  const [state, setState] = useState({
    loading: false,
    current: 0
  });
  useEffect(() => {
    if (isCurrent && !state.loading) {
      WrapperRef.current.children[state.current].focus();
    }
  }, [state.current, isCurrent]);
  const submit = async text => {
    setState({ ...state, loading: true });
    try {
      let response = await fetchModule.post(
        "",
        createSendForm(
          {
            type: API.verifyCode,
            temporarycode: text,
            mobilenumber: lstool.get("phone")
          },
          false,
          "multiPart"
        )
      );
      if (response === true) {
        nextStep();
        setState({ ...state, loading: false });
      } else {
        toast.warn("کد وارد شده معتبر نمیباشد");
        for (let item of WrapperRef.current.children) {
          item.value = "";
        }
        setState({ loading: false, current: 0 });
      }
    } catch (error) {
      toast.error("مشکلی پیش آمده.دوباره تلاش کنید");
    }
  };
  const setNumb = e => {
    if (!e.target.value) return;
    if (e.target.nextSibling) {
      setState({ ...state, current: state.current + 1 });
    } else {
      e.target.disabled = true;
      let value = "";
      WrapperRef.current.childNodes.forEach(ob => {
        value += ob.value;
      });
      submit(value);
    }
  };
  const backward = e => {
    if (e.keyCode === 8) {
      if (e.target.previousSibling) {
        setState({ ...state, current: state.current - 1 });
        e.target.previousSibling.value = "";
      } else {
        e.target.value = "";
      }
    }
  };
  return (
    <>
      {state.loading ? <Loading></Loading> : null}
      <RegisterWrapper>
        <div>
          <img
            css={css`
              max-height: 200px;
            `}
            src={Pic}
          ></img>
        </div>
        <div>
          <Title>کد ارسال شده را وارده کنید</Title>
          <LoginInputWrapper
            css={css`
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              direction: ltr;
            `}
            ref={WrapperRef}
          >
            {["", "", "", ""].map((a, index) => (
              <VerifyInput
                disabled={state.current !== index && !state.loading}
                key={index}
                onChange={setNumb}
                onKeyUp={backward}
                type="tel"
              ></VerifyInput>
            ))}
          </LoginInputWrapper>
        </div>
        <div>
          {isCurrent ? <ResendVerify></ResendVerify> : null}
          <a
            href="#"
            css={css`
              color: var(--color2);
              font-size: 1.2rem;
            `}
            onClick={e => {
              e.preventDefault();
              prevStep();
            }}
          >
            شماره تلفن خود را اشتباه وارد کردید؟
          </a>
        </div>
      </RegisterWrapper>
    </>
  );
}
export default VerifyPhone;
